import Papa, { ParseConfig } from 'papaparse'

export function parseClipboard<T = unknown>(clipboard: string, config?: ParseConfig<T>) {
  const parseResult = Papa.parse<T>(clipboard, {
    delimiter: '\t',
    header: true,
    transformHeader: (h: string) => h.trim(),
    dynamicTyping: true,
    skipEmptyLines: true,
    ...config
  })
  if (parseResult.errors.length > 0) {
    throw new Error('Invalid clipboard content')
  }
  if (parseResult.data.length === 0) {
    throw new ClipboardParseNoRowsFoundError()
  }
  return parseResult.data
}

export class ClipboardParseNoRowsFoundError extends Error {
  message = 'No rows found'

  constructor() {
    super()
  }
}
